import { configureStore } from "@reduxjs/toolkit";
import {
  useDispatch,
  useSelector,
  type TypedUseSelectorHook,
} from "react-redux";
import { USER_SLICE_LABEL } from "./storeLabels";
import { listenerMiddleware } from "./middleware";
import { initialUserState, UserSlice } from "./slices/user";
export const store = configureStore({
  reducer: {
    auth: UserSlice.reducer,
  },

  // ? Preload state from local storage
  preloadedState: {
    auth: localStorage.getItem(USER_SLICE_LABEL)
      ? JSON.parse(localStorage.getItem(USER_SLICE_LABEL) as string)
      : initialUserState,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(listenerMiddleware.middleware),
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof store.getState>;
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
